import React from 'react';
import { ProgressBar } from 'react-aria-components';

import { tv } from '../../tv';

/**
 * The one ring the system turns: a bordered disc with its top edge open, a
 * full turn a second, in `currentColor`. Button and Menu draw their pending
 * ring from this recipe at their own steps, and the standalone `Spinner`
 * stands where content has no shape yet to skeleton (loading.md). It takes
 * its colour from the text around it; a region that wants the accent is a
 * `LoadingState`. rounded-full, not a radius step: the disc must stay
 * circular whatever the radius factor is set to.
 */
export const spinnerStyles = tv({
  base: 'ck:animate-spin ck:rounded-full ck:border-current ck:border-t-transparent',
  variants: {
    size: {
      xs: 'ck:size-3 ck:border-2',
      sm: 'ck:size-4 ck:border-2',
      md: 'ck:size-6 ck:border-2',
      lg: 'ck:size-8 ck:border-3',
    },
  },
  defaultVariants: { size: 'md' },
});

const spinnerRoot = tv({ base: 'ck:inline-flex ck:shrink-0' });

export interface SpinnerProps {
  /** 16, 24 or 32px. The 12px step is Button's own. */
  size?: 'sm' | 'md' | 'lg';
  /** What is loading, for assistive technology. */
  label?: string;
  id?: string;
}

export const Spinner = React.forwardRef<HTMLDivElement, SpinnerProps>(function Spinner(
  { size = 'md', label = 'Loading', id },
  ref,
) {
  return (
    <ProgressBar
      ref={ref}
      id={id}
      aria-label={label}
      isIndeterminate
      className={spinnerRoot()}
      data-component="spinner"
    >
      <span className={spinnerStyles({ size })} />
    </ProgressBar>
  );
});
